module.exports = __webpack_public_path__ + "img/Republic-of-Congo.b96430d6.png";